function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", {
  id: "img-personalisierung--pka-default_svg__personalisierung-pka-title"
}, "Illustration-Aktenkoffer-Tablettenpackung");

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "img-personalisierung--pka-default_svg__personalisierung-pka-desc"
}, "Niedrig-Detail-Darstellung einer Tablettenpackung hinter einem Aktenkoffer, jeweils mit blauen Streifen zur Hervorhebung.");

var _ref3 = /*#__PURE__*/React.createElement("style", null, ".img-personalisierung--pka-default_svg__stripes{fill:#39a5d2}");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "img-personalisierung--pka-default_svg__Exporte",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "img-personalisierung--pka-default_svg__img-personalisierung--pka-default"
}, /*#__PURE__*/React.createElement("g", {
  id: "img-personalisierung--pka-default_svg__Group-2",
  transform: "translate(11 18)"
}, /*#__PURE__*/React.createElement("path", {
  className: "img-personalisierung--pka-default_svg__stripes",
  d: "M48 21h14v64H48a6 6 0 01-6-6V27a6 6 0 016-6z",
  id: "img-personalisierung--pka-default_svg__Rectangle",
  transform: "rotate(-180 52 53)"
}), /*#__PURE__*/React.createElement("path", {
  className: "img-personalisierung--pka-default_svg__stripes",
  id: "img-personalisierung--pka-default_svg__Rectangle",
  d: "M42 13h11v8H42z"
}), /*#__PURE__*/React.createElement("path", {
  className: "img-personalisierung--pka-default_svg__stripes",
  id: "img-personalisierung--pka-default_svg__Rectangle-Copy-2",
  d: "M42 0h16v13H42z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  fill: "#FFF",
  x: 0,
  y: 21,
  width: 62,
  height: 64,
  rx: 7
}), /*#__PURE__*/React.createElement("path", {
  className: "img-personalisierung--pka-default_svg__stripes",
  d: "M48 21h14v64H48a6 6 0 01-6-6V27a6 6 0 016-6z",
  id: "img-personalisierung--pka-default_svg__Rectangle",
  transform: "rotate(-180 52 53)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6,
  x: 0,
  y: 21,
  width: 62,
  height: 64,
  rx: 7
}), /*#__PURE__*/React.createElement("path", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6,
  d: "M0 39h62v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6,
  fill: "#FFF",
  d: "M9 13h44v8H9z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "img-personalisierung--pka-default_svg__Rectangle-Copy",
  stroke: "#151616",
  strokeWidth: 1.6,
  fill: "#FFF",
  x: 4,
  y: 0,
  width: 54,
  height: 13,
  rx: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "img-personalisierung--pka-default_svg__Group",
  transform: "translate(31 29)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6,
  fill: "#FFF",
  x: 0,
  y: 7,
  width: 67,
  height: 49,
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  className: "img-personalisierung--pka-default_svg__stripes",
  d: "M49.245 7H59a8 8 0 018 8v35a6 6 0 01-6 6h-5V18.723c0-5.96-2.252-9.868-6.755-11.723z",
  id: "img-personalisierung--pka-default_svg__Rectangle"
}), /*#__PURE__*/React.createElement("rect", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6,
  x: 0,
  y: 7,
  width: 67,
  height: 49,
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 7V2a2 2 0 012-2h15a2 2 0 012 2v5h0",
  id: "img-personalisierung--pka-default_svg__Path-7",
  stroke: "#151616",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 7h55a6 6 0 016 6v8.5C67 29.508 60.508 36 52.5 36h-38C6.492 36 0 29.508 0 21.5V13a6 6 0 016-6z",
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "img-personalisierung--pka-default_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.6,
  fill: "#FFF",
  d: "M16 31h6v10h-6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "img-personalisierung--pka-default_svg__Rectangle-Copy-3",
  stroke: "#151616",
  strokeWidth: 1.6,
  fill: "#FFF",
  d: "M45 31h6v10h-6z"
})))));

function SvgImgPersonalisierungPkaDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    "aria-labelledby": "personalisierung-pka-title personalisierung-pka-desc"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,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";
export { SvgImgPersonalisierungPkaDefault as ReactComponent };